import React from 'react'
import styled from 'styled-components'

const MergedPillSvg = styled.svg`
    width: 78px;
    vertical-align: middle;
`

type Props = {
    className?: string
}

const MergedPill = ({ className = '' }: Props) => (
    <MergedPillSvg
        className={className}
        width="78px"
        height="31px"
        viewBox="0 0 78 31"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M2,0 L66,0 C67.1045695,-2.02906125e-16 68,0.8954305 68,2 L68,19 C68,20.1045695 67.1045695,21 66,21 L2,21 C0.8954305,21 1.3527075e-16,20.1045695 0,19 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z M8.754,15 L8.754,10.008 L10.854,12.54 L11.274,12.54 L13.422,9.996 L13.422,15 L15.774,15 L15.774,6.6 L13.302,6.6 L11.094,9.444 L8.886,6.6 L6.402,6.6 L6.402,15 L8.754,15 Z M24.798,15 L24.798,12.996 L20.418,12.996 L20.418,11.724 L24.39,11.724 L24.39,9.792 L20.418,9.792 L20.418,8.592 L24.63,8.592 L24.63,6.6 L18.078,6.6 L18.078,15 L24.798,15 Z M29.118,15 L29.118,12.276 L29.946,12.276 L31.902,15 L34.518,15 L34.518,14.856 L32.334,12.024 C33.75,11.4 34.11,10.524 34.11,9.492 C34.11,7.98 32.994,6.6 30.846,6.6 L26.742,6.6 L26.742,15 L29.118,15 Z M30.87,10.512 L29.118,10.512 L29.118,8.496 L30.846,8.496 C31.47,8.496 31.77,9.012 31.77,9.54 C31.77,10.044 31.494,10.512 30.87,10.512 Z M40.23,15.228 C41.85,15.228 43.314,14.652 43.842,13.584 L43.842,9.852 L39.738,9.852 L39.738,11.712 L41.862,11.712 L41.862,12.792 C41.382,13.14 40.686,13.224 40.242,13.224 C38.55,13.224 37.986,11.892 37.986,10.812 C37.986,9.168 38.874,8.352 40.242,8.352 C40.806,8.352 41.55,8.508 42.162,9.084 L43.542,7.716 C42.438,6.6 41.406,6.36 40.242,6.36 C37.086,6.36 35.646,8.616 35.646,10.812 C35.646,13.008 36.906,15.228 40.23,15.228 Z M52.506,15 L52.506,12.996 L48.126,12.996 L48.126,11.724 L52.098,11.724 L52.098,9.792 L48.126,9.792 L48.126,8.592 L52.338,8.592 L52.338,6.6 L45.786,6.6 L45.786,15 L52.506,15 Z M58.05,15 C61.062,15 62.442,13.056 62.442,10.74 C62.442,8.424 61.014,6.6 58.05,6.6 L54.45,6.6 L54.45,15 L58.05,15 Z M58.05,12.996 L56.802,12.996 L56.802,8.58 L58.05,8.58 C59.502,8.58 60.09,9.564 60.09,10.716 C60.09,11.868 59.562,12.996 58.05,12.996 Z"
                id="path-1"
            ></path>
            <filter x="-12.5%" y="-31.0%" width="125.0%" height="181.0%" filterUnits="objectBoundingBox" id="filter-2">
                <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix
                    values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
                    type="matrix"
                    in="shadowBlurOuter1"
                ></feColorMatrix>
            </filter>
        </defs>
        <g id="designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="merge-gifs" transform="translate(-367.000000, -1480.000000)">
                <g id="collection-counter-copy" transform="translate(372.000000, 1483.000000)">
                    <g id="Combined-Shape">
                        <use fill="black" fillOpacity="1" filter="url(#filter-2)" xlinkHref="#path-1"></use>
                        <use fill="#FFFFFF" fillRule="evenodd" xlinkHref="#path-1"></use>
                    </g>
                </g>
            </g>
        </g>
    </MergedPillSvg>
)

export default MergedPill
